<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="GLOSSARY">
<header>
<p class="h2f" id="bk4glo"><span class="right_1" epub:type="pagebreak" id="page_320" title="320"><span class="right_1" epub:type="pagebreak" id="page_321" title="321"><a href="#/text/nav#rbk4glo">GLOSSARY</a></span></span></p>
</header>
<p class="hang"><i>ab im kopp</i>—crazy, crazy in the head</p>
<p class="hang"><i>daag/daags</i>—day/days</p>
<p class="hang"><i>daed</i>—dad</p>
<p class="hang"><i>danki</i>—thank you</p>
<p class="hang"><i>dawdi haus</i>—small house used for in-laws/parents/grandparents</p>
<p class="hang"><i>familye</i>—family</p>
<p class="hang"><i>geh</i>—go</p>
<p class="hang"><i>grossdaadi</i>—grandfather</p>
<p class="hang"><i>gut</i>—good</p>
<p class="hang"><i>gute nacht</i>—good night</p>
<p class="hang"><i>haus</i>—house</p>
<p class="hang"><i>kaffee</i>—coffee</p>
<p class="hang"><i>kapp</i>—white hat worn by Amish women</p>
<p class="hang"><i>maed</i>—girls</p>
<p class="hang"><i>mamm</i>—mom</p>
<p class="hang"><i>mei</i>—my</p>
<p class="hang"><i>nee</i>—no</p>
<p class="hang"><i>sehr</i>—very</p>
<p class="hang"><i>sohn</i>—son</p>
<p class="hang"><i>ya</i>—yes</p>
<p class="hang"><i>yer</i>—your</p>
<p class="hang"><i>yers</i>—yours</p>
<p class="hang"><i>yerself</i>—yourself</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780718023676_Book_4glo.vue?1e0ed6a2